import {FC} from 'react';
import Button, {ButtonProps} from 'components/Button';

export type ModalButtonProps = Omit<ButtonProps, 'type'> & {
    type: 'cancel' | 'submit';
};

const ModalButton: FC<ModalButtonProps> = ({type, ...rest}) => (
    <Button
        data-modal-button-type={type}
        type={type === 'submit' ? 'submit' : 'button'}
        {...rest}
    />
);

export default ModalButton;
